import { useTranslation } from 'react-i18next';
import { ChevronDown, Bike, UtensilsCrossed, Building2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '../ui/dropdown-menu';

const FORM_OPTIONS = [
  { value: 'restaurant', icon: UtensilsCrossed, key: 'v2_apply_restaurant' },
  { value: 'courier', icon: Bike, key: 'v2_apply_courier' },
  { value: 'company', icon: Building2, key: 'v2_apply_company' },
];

export const ApplyDropdown = ({ onSelect, size = 'md', testIdPrefix = 'apply', align = 'center' }) => {
  const { t } = useTranslation();

  const sizeClass =
    size === 'lg'
      ? 'px-8 py-4 text-base sm:text-lg rounded-2xl gap-3'
      : size === 'sm'
      ? 'px-4 py-2 text-sm rounded-full gap-1.5'
      : 'px-5 py-2.5 text-sm rounded-full gap-2';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`neon-btn-purple inline-flex items-center justify-center font-semibold text-white ${sizeClass} group`}
          data-testid={`${testIdPrefix}-dropdown-trigger`}
        >
          {t('v2_apply_dropdown', 'Başvurular')}
          <ChevronDown className="w-4 h-4 transition-transform group-data-[state=open]:rotate-180" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        sideOffset={8}
        collisionPadding={16}
        className="w-64 bg-popover/95 backdrop-blur-xl neon-border-purple text-foreground p-2"
      >
        {FORM_OPTIONS.map(({ value, icon: Icon, key }) => (
          <DropdownMenuItem
            key={value}
            onSelect={() => onSelect(value)}
            className="cursor-pointer rounded-lg px-3 py-3 focus:bg-fuchsia-500/15 focus:text-foreground text-foreground/90"
            data-testid={`${testIdPrefix}-option-${value}`}
          >
            <Icon className="w-4 h-4 mr-3 text-fuchsia-500 dark:text-fuchsia-400" />
            <span className="font-medium">{t(key)}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ApplyDropdown;
